export const composeValidators =
  (...validators) =>
  (value) =>
    validators.reduce((error, validator) => error || validator(value), undefined);

export const required = (value) => (value ? undefined : "Required");

export const mustBeLetters = (value) => (value.match(/^[a-zA-Z]+$/) ? true : "Must be letters only");

export const validEmailAddress = (value) =>
  value.match(/\S+@\S+\.\S+/) ? true : "Email address must be in the format example@example.com";

export const mustBeNumbers = (value) => (value.match(/^[0-9]+$/) ? true : "Must be numbers only");

export const numbersUpToTwoDecimalPlaces = (value) =>
  (value.match(/^\d*\.?\d{0,2}$/) ? true : "Must be a number with up to 2 decimal places");
